import { render } from "./PageNotFound.vue?vue&type=template&id=2a12e54e"
import script from "./PageNotFound.vue?vue&type=script&lang=js"
export * from "./PageNotFound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/PageNotFound.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a12e54e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a12e54e', __exports__)) {
    api.reload('2a12e54e', __exports__)
  }
  
  module.hot.accept("./PageNotFound.vue?vue&type=template&id=2a12e54e", () => {
    api.rerender('2a12e54e', render)
  })

}


export default __exports__